import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ScrollToTop from '@/shared/components/ScrollToTop';
import ClientTasksSyncBoard from '@/views/ClientTasksSyncBoard';

// const HomePage = lazy(() => import('@/views/Home/HomePage'));
const NotFoundPage = lazy(() => import('@/views/NotFound/NotFoundPage'));
export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p></p>
      </div>}>
        <Routes>
          <Route path="/" element={<ClientTasksSyncBoard />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
